import { createSlice } from "@reduxjs/toolkit";
import { onGetRewardPointList, onAddRewardPoint, onUpdateRewardPoint, onDeleteRewardPoint } from "./thunk";


export const initialState = {
  rewardPointList: [],
  errors: {}
};

const RewardSlice = createSlice({
  name: 'Reward',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // reward-point
    builder.addCase(onGetRewardPointList.fulfilled, (state: any, action: any) => {
      state.rewardPointList = action.payload;
    });
    builder.addCase(onGetRewardPointList.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onAddRewardPoint.fulfilled, (state: any, action: any) => {
      state.rewardPointList.unshift(action.payload);
    });
    builder.addCase(onAddRewardPoint.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onUpdateRewardPoint.fulfilled, (state: any, action: any) => {
      state.rewardPointList = state.rewardPointList.map((list: any) =>
        list.rewardPointsId === action.payload.rewardPointsId
          ? { ...list, ...action.payload }
          : list
      );
    });
    builder.addCase(onUpdateRewardPoint.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onDeleteRewardPoint.fulfilled, (state: any, action: any) => {
      state.rewardPointList = state.rewardPointList.map((list: any) =>
        list.rewardPointsId === action.payload.rewardPointsId
          ? { ...list, ...action.payload }
          : list
      );
    });
    builder.addCase(onDeleteRewardPoint.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
  }
});

export default RewardSlice.reducer;